
var ProductListChunkUrl = cyclone3.domain + '/' + cyclone3.lng + '/chunk/products';
var ProductListMain = $('#main_product_list');
var ProductPagination = $('#pagination');
var productListBtn = $('button.load-more-products');
        
function product_list_load() {
        
    var dataSet = product_list_get_dataset();
    dataSet['page_offset'] = 0;

    product_list_get(dataSet);
}

function product_list_get_dataset() {
    
    var dataSet = {};
    var required = ['page_limit', 'page_offset', 'node', 'q', 'sort', 'oid'];
    
    required.forEach(function (dataAttr) {
        if (productListBtn.data(dataAttr) != '')
        {
            dataSet[dataAttr] = productListBtn.data(dataAttr);
        }      
    });
    
    // facet
    $('#facet').find(".config-facet a").each(function () {
        if ($(this).hasClass('active')) {
            dataSet[$(this).data('param')] =  $(this).data('value');
        }
    });
    
    return dataSet;
}

var facet = {
    'initialize': function(initial) {
        var uri = cyclone3.domain + "/json/" + cyclone3.lng + "/facet?node=" + productListBtn.data("node") + "&oid=" + productListBtn.data("oid");
        
        $.ajax
        (
            {
                type: "GET",
                url: uri,
                dataType: "json",
                xhrFields: {
                    withCredentials: true
                },
                success: function(json)
                {
                    var facetWrapper = $('#facet');
                    $.each(json.fields, function(key, param) {
                        
                        var field = key.replace(/^.*?\./,'').replace(/^p_/,'');
                        
                        if (field == "price" || field == "main") {
                            return;
                        }
                        
                        if(param.count == "0")
                        {
                            return;
                        }

                        var output =
                        '<div class="widget">'
                            +'<h3 class="widget-title"><a data-toggle="collapse" href="#collapse_'+field+'" role="button" aria-expanded="true" aria-controls="collapse_'+field+'">' + param.label +'</a></h3>'
                            +'<div id="collapse_'+field+'" class="collapse show">'
                                +'<div class="widget-body">'
                                    +'<ul id="p_'+field+'"class="cat-list config-facet">';
                        
                        $.each(param.items, function(name, item) {									
                            var checked = '';
                            if (item.checked == 'true') {
                                checked = ' class="active"';
                            }
                            output +=
                            '<li ><a '+checked
                                    +' data-value="'+name+'"'
                                    +' data-param="p_'+field+'">'
                                +item.label+'<span>'+item.count+'</span></a>'
                            +'</li>';										
                        });						
                        
                        output += '</ul>'
                                +'</div>'
                            +'</div>'
                        +'</div>'
                            
                        $(output).appendTo(facetWrapper);
                    });
                }
            }
        );
    }
};

function product_list_get(dataSet) {

    ProductListMain.css('opacity','.4');

    $.ajax({
        url: ProductListChunkUrl,
        data: dataSet,
        xhrFields: {
            withCredentials: true
        }
    }).done(function (data) {
                
        var newProductListMain = $(data).filter('#main_product_list');
        var newProductPagination = $(data).filter('#pagination');

        ProductListMain.html(newProductListMain.html());
        ProductPagination.html(newProductPagination.html());
        
    }).fail(function (error) {
        console.log(error);
    }).always(function(){
        ProductListMain.css('opacity','100');
    });
};


(function ($) {
    
	$(document).on('click', 'button.load-more-products', function (){

        productListBtn = $(this);
	  
        if( productListBtn.hasClass('loading') ) {
			return false;
		}

        product_list_get(product_list_get_dataset()); 

		productListBtn.attr('disabled', true).addClass('loading');
     
	});
    
    $('#sort').change(function(){
        productListBtn.data('sort',$(this).val());
        product_list_load();
    });
    
    
	$(document).on('click', '.config-facet a, .toolbox-right a', function(){
        var selected = $(this);
        
        $('#'+ selected.data('param')).find('a').each(function (i, el) {
            if ($(el).data('value')!= selected.data('value')) {
                $(el).removeClass('active');          
            }
        });
        
        if (selected.hasClass('active')) {
            selected.removeClass('active');
        } else {
            selected.addClass('active');
        }
        
        // toolbox nav
        var data_param_selector = '[data-param="' + selected.data('param') + '"]',
            data_value_selector = '[data-value="' + selected.data('value') + '"]',
            toolbox = $('.toolbox-right'),
            facet = $('.config-facet'),
            toolbox_selected = '';


        if (toolbox.find($(data_value_selector)).length) {

            // cistim existujuci
            toolbox.find($(data_value_selector)).remove();
            facet.find($(data_value_selector)).removeClass('active');

        } else {
            if (toolbox.find($(data_param_selector)).length) {

                // odstranim z rovnakej kategorie
                toolbox.find($(data_param_selector)).remove();
            }

            // upravim
            toolbox_selected = selected.clone();
            toolbox_selected.find('span').replaceWith('<i class="icon-cancel"></i>');
            // naplnim
            toolbox_selected.prependTo(toolbox);
        }
        
        product_list_load();        
    });
    
    $(document).ready(function () {
        if ( $( "#facet" ).length ) {     
            facet.initialize();         
        }
    });

    
})(jQuery);